import { InternalId } from '@edgebox/data-definition-kit';
import { ClientSyndicationEntity } from '@edgebox/sync-core-rest-client';
import React from 'react';
import { ISyncCoreApiComponentState, SyncCoreApiComponent } from '../services/SyncCoreApiComponent';

interface IProps {
  entityId?: InternalId;
  includeUsage?: boolean;
  children: (entity?: ClientSyndicationEntity) => React.ReactNode;
}

interface IState extends ISyncCoreApiComponentState {
  entity?: ClientSyndicationEntity;
  loaded?: boolean;
}

export class WithSyndication extends SyncCoreApiComponent<IProps, IState> {
  async load() {
    try {
      if (this.props.entityId) {
        const entity = await this.api.syndication.syndications.item(this.props.entityId, false, { includeUsage: this.props.includeUsage });
        return {
          loaded: true,
          entity,
        };
      }
    } catch (e) {}
    return {
      loaded: true,
    };
  }

  render() {
    const { children } = this.props;
    const { loaded, entity } = this.state;

    if (!loaded) {
      return this.renderRequest();
    }

    return children(entity);
  }
}
